import { render, staticRenderFns } from "./bosch.vue?vue&type=template&id=5d3f169e&"
import script from "./bosch.vue?vue&type=script&lang=js&"
export * from "./bosch.vue?vue&type=script&lang=js&"
import style0 from "./bosch.vue?vue&type=style&index=0&id=5d3f169e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports